module.exports = __webpack_public_path__ + "static/media/Hero.78479917.png";